import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import MyButton from '../../../utils/MyButton'
import { FaArrowCircleLeft, FaChartBar } from 'react-icons/fa'


import './TareasPerfil.css'
import TablaTareas from './TablaTareas'


export class TareasPerfil extends Component {
  render() {
    return (
        <div>
        <div className="titulo_section">
        <div className="titulo_clientes">
        <h1 className="text-clientes">Tareas </h1>
        <hr className="clientes_separator"></hr>            
        
        </div>

        <div className="div_boton">
        <Link to={`/dashboard/perfilcliente/${this.props.match.params.clienteId}`}>
        <MyButton tip="Volver">
         <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente"/>
        </MyButton>
        </Link>
        </div>
        </div>

<div className='container-inventario-perfil'>

                

                                    <div className="div-tabla-equipos">
                                    <div className="div-tabla-equipos">
        <TablaTareas clienteId={this.props.match.params.clienteId}></TablaTareas>
        </div>
        </div>
</div>
 
       
        
        </div>
    )
  }
}

export default TareasPerfil